// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-b7b593b4] .m-input-icon.m-input-icon--right .form-control:hover::placeholder {\n  color: #575962;\n}\n", ""]);
// Exports
module.exports = exports;
